<template>
<div>
    <Header title="订单列表" />
    <van-tabs ref="tabs" color="#7181EB" title-active-color="#7181EB" v-model="active" @click="onClickTab()">
        <van-tab :title="item" v-for="(item, index) in type" :key="index">
            <div class="scrollerView">
                <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
                    <PointOrderItem v-for="(item, _index) in dataSources" :key="_index" :item="item" :type="index" v-on:refresh="refresh" />
                    <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
                </scroller>
            </div>
        </van-tab>
    </van-tabs>
    <img class="service" :src="Images.img_service" alt="">
</div>
</template>

<script>
import Header from '@/components/Header'
import FooterShop from '@/components/FooterShop'
import PointOrderItem from '@/components/item/PointOrderItem'
export default {
    /** 组件挂载 */
    components: {
        Header,
        FooterShop,
        PointOrderItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: true,
            type: ['待发货', '待收货', '已完成'],
            tab_read: [this.$route.query.type * 1 || 0], //记录下seg的点击顺序
            status: [
                'WAIT_SELLER_SEND_GOODS', // 等待卖家发货
                'WAIT_BUYER_CONFIRM_GOODS', //等待买家确认收货， 
                'TRADE_SUCCESS', // 买家已签收以及订单成功，
            ],
            active: this.$route.query * 1 || 0,
            page: 0,
            limit: 10,
            dataSources: [],

        };
    },
    /** 挂载前 */
    created() {

    },
    /** 挂载后 */
    mounted() {
        let {
            type
        } = this.$route.query
        this.active = type * 1 || 0
    },
    /** 方法 */
    methods: {
        // -------------------------------------------------- request  --------------------------------------------------
        async requestData() {
            let url = this.API.point_shop_order_list;
            let params = {page: this.page,
                limit: this.limit,
                status: this.status[this.active],
            };
            let result = await this.$post(url, params);
            this.loading = false;
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSources = dataSourcesTemp
                that.$refs.infinite[this.tab_read.indexOf(this.active)].finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- mothed  --------------------------------------------------
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite[this.tab_read.indexOf(this.active)].finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // -------------------------------------------------- onPress  --------------------------------------------------
        // 点击跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },
        // 点击tab
        onClickTab() {
            // 对于seg的点击顺序优化
            this.dataSources = [];
            if (this.tab_read.length < 5) {
                if (this.tab_read.indexOf(this.active) === -1) {
                    this.dataSources = []
                    let array = this.tab_read.slice();
                    array.push(this.active)
                    this.tab_read = array
                    this.refresh();
                } else {
                    this.refresh();
                }
            } else {
                this.refresh();
            }
        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
    height: calc(100vh - 100px);
}

.scroller {
    background: #F8F8F8;
}

.service {
    position: fixed;
    right: 15px;
    bottom: 100px;
    width: 55px;
    height: 55px;
}
</style>
